module.exports = __webpack_public_path__ + "static/media/vectorR.0ffc9c3e.svg";